import React from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';
import { Container, Typography, Grid, Paper } from '@mui/material';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import IntegrationInstructionsIcon from '@mui/icons-material/IntegrationInstructions';
import SecurityIcon from '@mui/icons-material/Security';

const StyledSection = styled('section')(({ theme }) => ({
  backgroundColor: '#000',
  color: 'white',
  padding: theme.spacing(10, 0),
}));

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  backgroundColor: '#181818',
  borderRadius: theme.spacing(1),
  transition: 'transform 0.3s ease',
  textAlign: 'center',
  '&:hover': {
    transform: 'translateY(-5px) scale(1.04)',
  },
}));

const IconWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginBottom: theme.spacing(2),
  fontSize: 48,
  color: theme.palette.primary.main,
  transition: 'transform 0.4s cubic-bezier(.4,2,.6,1)',
  '.MuiPaper-root:hover &': {
    transform: 'scale(1.15) rotate(-8deg)',
    color: theme.palette.secondary.main,
  },
}));

const advantages = [
  {
    key: 'multiPortFlexibility',
    titleKey: 'multiPortFlexibility',
    descKey: 'multiPortFlexibilityDesc',
    icon: <SwapHorizIcon fontSize="inherit" />,
  },
  {
    key: 'transitTimeEfficiency',
    titleKey: 'transitTimeEfficiency',
    descKey: 'transitTimeEfficiencyDesc',
    icon: <AccessTimeIcon fontSize="inherit" />,
  },
  {
    key: 'integratedServices',
    titleKey: 'integratedServices',
    descKey: 'integratedServicesDesc',
    icon: <IntegrationInstructionsIcon fontSize="inherit" />,
  },
  {
    key: 'secureOperations',
    titleKey: 'secureOperations',
    descKey: 'secureOperationsDesc',
    icon: <SecurityIcon fontSize="inherit" />,
  },
];

const StrategicAdvantages = () => {
  const { t } = useTranslation();

  return (
    <StyledSection id="advantages">
      <Container>
        <Typography variant="h2" component="h2" align="center" gutterBottom>
          {t('advantages.title')}
        </Typography>
        <Grid container spacing={4} justifyContent="center">
          {advantages.map((adv, idx) => (
            <Grid item xs={12} sm={6} md={3} key={adv.key}>
              <StyledPaper>
                <IconWrapper>{adv.icon}</IconWrapper>
                <Typography variant="h4" gutterBottom>
                  {t(`advantages.${adv.titleKey}`)}
                </Typography>
                <Typography>
                  {t(`advantages.${adv.descKey}`)}
                </Typography>
              </StyledPaper>
            </Grid>
          ))}
        </Grid>
      </Container>
    </StyledSection>
  );
};

export default StrategicAdvantages; 